// removed by extract-text-webpack-plugin
module.exports = {"Countdown":"CountdownTimer__Countdown__2pv5C","FlipClock":"CountdownTimer__FlipClock__1ywvG","Labels":"CountdownTimer__Labels__22nqu"};